export const ADMIN_ROLES = ['Project Admin'];
export const LUNCH_BREAK = 'Lunch Break';
